import { JWT } from '../types';
import { MINIMAL_TOKENS_LIMIT } from '../const';

export const getAllowedAddProjectTokenIndex = (
  maxTokensLimit: number,
  decryptedTokens: JWT[],
) => {
  if (maxTokensLimit < MINIMAL_TOKENS_LIMIT) {
    return -1;
  }

  return new Array(maxTokensLimit - 1)
    .fill('')
    .map((_, index) => index + 1)
    .filter(
      index => decryptedTokens.findIndex(item => item.index === index) === -1,
    )
    .sort((a, b) => a - b)[0];
};
